import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  forwardRef,
  input,
  output,
  Signal,
  signal,
  viewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslatePipe } from '@softline/ui-core';
import { FormatPipe } from '@softline/ui-core';
import { IconComponent } from '@softline/ui-core';
import { DateRangeFieldInput } from '../date-range-field-input';
import {
  DateRangeInputPickerTrigger,
  DateRangeInputSize,
} from '../date-range-input.types';
import type { DateRangeFromInputComponent } from '../date-range-from-input/date-range-from-input.component';

@Component({
  selector: 'soft-date-range-to-input, soft-ds-date-range-to-input',
  imports: [TranslatePipe, FormatPipe, IconComponent],
  templateUrl: './date-range-to-input.component.html',
  styleUrl: './date-range-to-input.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeToInputComponent),
      multi: true,
    },
  ],
  host: {
    '[class]': 'hostClasses()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeToInputComponent extends DateRangeFieldInput {
  override readonly valueInput: Signal<string | null> = input<string | null>(null);
  override readonly readonly: Signal<boolean> = input<boolean, unknown>(false, {
    transform: booleanAttribute,
  });
  override readonly disabledInput: Signal<boolean> = input<boolean, unknown>(false, {
    alias: 'disabled',
    transform: booleanAttribute,
  });
  override readonly placeholder: Signal<string> = input<string>(
    '#UI_CORE.COMPONENTS.DATE_INPUT.PLACEHOLDER'
  );
  override readonly inputId: Signal<string | null> = input<string | null>(null);
  override readonly changeTrigger: Signal<'blur' | 'input'> = input<'blur' | 'input'>(
    'blur'
  );
  override readonly format: Signal<string> = input<string>('DATE.DEFAULT');
  override readonly pickerTrigger: Signal<DateRangeInputPickerTrigger> =
    input<DateRangeInputPickerTrigger>('modal');
  readonly size = input<DateRangeInputSize>('lg');
  protected override readonly inputElementRef =
    viewChild<ElementRef<HTMLInputElement>>('inputElement');
  protected override field: 'from' | 'to' = 'to';

  override readonly textInput = signal<string | null>(null);
  override readonly disabled = signal<boolean>(false);
  override readonly value = signal<string | null>(null);
  override readonly valueChange = output<string | null>();
  override readonly blur = output<void>();
  override readonly pickerOpen = output<'from' | 'to'>();

  readonly fromControl = input<DateRangeFromInputComponent | null>(null);
  override readonly otherControl = computed(() => this.fromControl());

  protected readonly hostClasses = computed(
    () =>
      `soft-date-range-to-input-host soft-ds-date-range-to-input-host size-${this.size()}` +
      (this.disabled() ? ' is-disabled' : '') +
      (this.readonly() ? ' readonly is-readonly' : '') +
      (this.value() ? ' is-filled' : '')
  );
}
